import { render, staticRenderFns } from "./UserImgProfile.vue?vue&type=template&id=6cdcb74d&scoped=true&"
import script from "./UserImgProfile.vue?vue&type=script&lang=js&"
export * from "./UserImgProfile.vue?vue&type=script&lang=js&"
import style0 from "./UserImgProfile.vue?vue&type=style&index=0&id=6cdcb74d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdcb74d",
  null
  
)

export default component.exports